import { NgModule } from '@angular/core';
import { NumericInputModule } from './numeric-input.module';

@NgModule({
    exports: [NumericInputModule]
})
export class NgNumericKeyboardModule { }
